import { styleSheetDataStructureSelector } from "@client/selectors";
import { nodesToPlain } from "@common/lib/tree";
import React from "react";
import { useSelector } from "react-redux";
import Item from "./Item/component";
import { getStyleSheetClassName } from "./lib";

export default () => {
  const structure = useSelector(styleSheetDataStructureSelector);
  const items = React.useMemo(() => nodesToPlain(structure).filter((x) => x.type), [structure]);

  return (
    <>
      {/* <Classes /> */}
      {items.map((x) => (
        <Item key={x.id} id={x.id} type={x.type!} rootSelector={`.${getStyleSheetClassName(x.type!, x.id)}`} />
      ))}
    </>
  );
};
